import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RxColComponent } from './rx-col.component';
@NgModule({
  imports: [CommonModule, RxColComponent],
  exports: [RxColComponent],
})
export class RxColModule {}
